var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"download"},[_c('wechat-tips',{ref:"wechat"}),_c('wechat-tips-for-ios',{ref:"wechatIos"}),_c('popup-download-tips',{ref:"download"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }